module.exports = __webpack_public_path__ + "img/grcns.c336a123.png";